import React from 'react';
import { ApiDashboard } from '../api';
import SalvPage from '../common/SalvPage';

const DashboardContainer = ({ dashboard, url }: { dashboard: ApiDashboard; url: string }) => {
  const iframeWidth = window.innerWidth - 320;
  const iframeHeight = 0.75 * iframeWidth;

  return (
    <SalvPage title={dashboard.name}>
      <iframe src={url} title={dashboard.name} style={{ border: 0 }} width={iframeWidth} height={iframeHeight} />
    </SalvPage>
  );
};

export default DashboardContainer;
